<script>
/**
 * This Mixin is used with some custom dialogs, such as the ZynyoEmailRequest, Zynyo and ScriptixTranscription dialog.
 * it groups common functionality for these dialogs.
 */
export default {
  name: 'DialogMixin',
  data () {
    return {
      dialogTop: 0,
      isDialogContentVisible: true
    }
  },
  computed: {
    dialogStackClass () {
      const idx = Math.min(Math.max(0, this.index || 0), 10)
      return `dialog--stack-${idx}`
    },
    dialogFocusClass () {
      return {
        'dialog--expanded': this.isDialogContentVisible,
        'dialog--collapsed-z': !this.isDialogContentVisible
      }
    },
    loaderProgressValue () {
      if (this.notification && typeof this.notification.progress === 'number') {
        return this.notification.progress
      }
      return this.progress || 0
    },
    loaderProgressClass () {
      const p = Math.min(100, Math.max(0, Math.round(this.loaderProgressValue)))
      return {
        [`loader--progress-${p}`]: p > 0 && p < 100,
        'loader--hidden': p >= 100 || p <= 0
      }
    },
    expandButtonClass () {
      return { 'expand-button--rotated': !this.isDialogContentVisible }
    }
  },
  watch: {
    isDialogContentVisible () {
      this.$nextTick(() => this.syncDialogZIndex())
    }
  },
  mounted () {
    this.syncDialogZIndex()
  },
  methods: {
    syncDialogZIndex () {
      const dialogs = document.querySelectorAll('.dialog')
      let highest = 5
      dialogs.forEach(dialog => {
        const zIndex = parseInt(window.getComputedStyle(dialog).zIndex, 10)
        if (zIndex > highest) highest = zIndex
      })
      dialogs.forEach(dialog => dialog.classList.remove('dialog--topmost'))
      if (this.isDialogContentVisible && this.$refs.zynyoDialog) {
        this.$refs.zynyoDialog.classList.add('dialog--topmost')
      } else if (this.isDialogContentVisible && this.$refs.scriptixDialog) {
        this.$refs.scriptixDialog.classList.add('dialog--topmost')
      }
      const el = this.$refs.zynyoDialog || this.$refs.scriptixDialog
      if (el && this.isDialogContentVisible) {
        el.dataset.zIndex = String(highest + 1)
      }
    },
    toggleDialogContent () {
      this.isDialogContentVisible = !this.isDialogContentVisible
      this.$nextTick(() => this.syncDialogZIndex())
    }
  }
}
</script>
<style lang="scss">
@media (min-width: 600px) {
    .dialog {
        width: 60% !important;
    }
}

@media (min-width: 1200px) {
    .dialog {
        width: 26% !important;
        right: 1rem !important;
        left: initial !important;
    }
}

@media (max-width: 500px) {
    .dialog {

      box-shadow: none !important;
    }
}
.dialog {
    width: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    bottom: 120px;
    z-index: 5;
    border-radius: 5px;

    left: 1.5rem;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px;
    padding-bottom: env(safe-area-inset-bottom);
    .close {
        background-color: transparent;
        border: none;
        cursor: pointer;
    }
}

.dialog--expanded {
  z-index: 1050;
}

.dialog--topmost {
  z-index: 1060 !important;
}

.dialog--collapsed-z {
  z-index: 5;
}

@for $i from 0 through 10 {
  .dialog--stack-#{$i} {
    transform: translate(0px, -#{$i * 61}px);
  }
}

.dialog-body {
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);
    height: 60px;
    width: 100%;
    overflow: hidden;
    transition: height 0.5s ease;
    &.expanded {
        height: auto;
    }

    .dialog-header {
        display: flex;
        padding: .9rem;
        padding-left: 10px;
        justify-content: space-between;
        align-items: center;

        h6 {
            margin: 0;
        }

        div {
            width: 15%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            button {
                background-color: transparent;
                border: none;
                cursor: pointer;
            }
        }
    }

    .dialog-footer {
        display: flex;
        justify-content: flex-end;
        position: relative;
        gap: 1rem;
        padding: .9rem;
        button,input {
            padding: 0.2rem .5rem;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            font-size: 0.8rem;
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .loader {
        position: absolute;
        left: 21px;
        width: 26px;
        height: 26px;
        border-radius: 50%;
        background: conic-gradient(#9fa1a3 0deg, #f0f3f5 0deg);
        transition: background 0.3s ease;
        top: 35%;
        border: 2px solid #9fa1a3;
    }

    .loader--hidden {
      display: none;
    }

    @for $p from 0 through 100 {
      .loader--progress-#{$p} {
        display: block;
        background: conic-gradient(#9fa1a3 #{$p * 3.6}deg, #f0f3f5 0deg);
      }
    }

    .font-sm {
        font-size: 0.8rem;
    }
}

.dialog-hr {
  margin: 0;
}

.dialog-content-padded {
  padding: .9rem;
  height: 90px;
}

.dialog-content-scroll {
  padding: .9rem;
  height: 300px;
}

.expand-button--rotated .expandButton {
  transform: rotate(180deg);
}

.expand .expandButton {
  transition: transform 0.3s ease;
}
</style>
